/**
 * Font Awesome Free Solid glyphs for DOM built at runtime.
 *
 * The PHP side renders icons through awdd_icon() (inc/icons.php), but a few
 * controls are created by JavaScript after load -- lightbox and gallery
 * chrome, the projects tile placeholder -- and cannot call it. Those used to
 * carry their own inlined <svg> strings, which is how eight copies of three
 * glyphs ended up spread across four modules, all of them missed when the
 * icon set moved from Lucide to Font Awesome.
 *
 * Keep this map in step with the PHP one: same names, same path data.
 */

// name => [ viewBox width, viewBox height, path data ].
const PATHS = {
	close: [384, 512, 'M55.1 73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L147.2 256 9.9 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192.5 301.3 329.9 438.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.8 256 375.1 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192.5 210.7 55.1 73.4z'],
	arrow: [512, 512, 'M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-105.4 105.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z'],
	image: [448, 512, 'M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm64 80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM272 224c8.4 0 16.1 4.4 20.5 11.5l88 144c4.5 7.4 4.7 16.7 .5 24.3S368.7 416 360 416L88 416c-8.9 0-17.2-5-21.3-12.9s-3.5-17.5 1.6-24.8l56-80c4.5-6.4 11.8-10.2 19.7-10.2s15.2 3.8 19.7 10.2l26.4 37.8 61.4-100.5c4.4-7.1 12.1-11.5 20.5-11.5z'],
};

/**
 * Match Font Awesome's sizing model: height drives the glyph, width follows
 * the aspect ratio. Callers pass square pairs inherited from the Lucide era,
 * so the bare w-* half is dropped here. Mirrors awdd_icon_classes() in PHP.
 *
 * w-auto and overflow-visible are written out literally so Tailwind's source
 * detection compiles them.
 */
function normaliseClasses(classes) {
	const kept = String(classes || '')
		.trim()
		.split(/\s+/)
		.filter((c) => c && !/^w-/.test(c));

	kept.push('w-auto', 'overflow-visible');
	return kept.join(' ');
}

/**
 * Render an icon as an SVG markup string.
 *
 * @param {string} name    Icon name, as in inc/icons.php.
 * @param {string} classes Classes applied to the <svg>.
 * @returns {string} SVG markup, or an empty string for an unknown name.
 */
export function icon(name, classes = 'h-5 w-5') {
	const glyph = PATHS[name];
	if (!glyph) return '';

	const [width, height, path] = glyph;

	return (
		`<svg class="${normaliseClasses(classes)}" viewBox="0 0 ${width} ${height}" ` +
		`fill="currentColor" aria-hidden="true" focusable="false"><path d="${path}"/></svg>`
	);
}
